import styled from "vue-styled-components";

export const Content = styled.div`
    display: grid;
    grid-template-areas: "A B" "C C";
    grid-template-columns: calc(180px + 1.5rem) calc(100% - (180px + 1.5rem));
    grid-row-gap: 1rem;

    figure {
        grid-area: A;
        display: flex;
        justify-content: center;
        width: 100%;
        flex: 0 0 180px;
        max-width: 180px;
        margin-right: 1.5rem;
        margin-bottom: 0;
        border: 1px solid #ccc;
        a {
            img {
                max-height: 200px;
                object-fit: contain;
            }
        }
    }

    .product-principal-cart {
        grid-area: B;
        align-self: center;

        h2 {
            font-size: 1.8rem;
            margin-bottom: 0;
            font-weight: 500;

            a {
                text-decoration: none;
                color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
            }
        }

        h2 + p {
            margin-top: 1.2rem;
        }

        .cart__flavor + .cart__flavor::before {
            content: ' / ';
        }

        .additional-files {
            margin-top: 1.3rem;
            a {
                text-decoration: none;
                display: flex;
                align-items: center;
                font-size: 1.3rem;
                font-weight: 400; 
                color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
            }
            i {
                font-size: 2.2rem;
                cursor: pointer;
                margin-right: 0.5rem;                
            }
            &:hover a strong {
                text-decoration: underline;
            }
        }
    }
    
    .additional-product-observation {
        grid-area: C;
    }

    p {
        color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        margin: 0.5rem 0 0;
        font-size: 1.3rem;
        font-weight: 400;        
    }

    @media (max-width: 767px) {
        grid-template-areas: "A A" "B B" "C C";
        margin-bottom: 1.5rem;

        figure {
            margin: 0;
            margin-inline: auto;
        }

        .additional-files {
            a {
                justify-content: center;
            }

            i.fa-image {
                margin: 0;
            }
        }
    }
`;
